import React, { useEffect, useState } from "react";
import { FormBox } from "./FormBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { TableBox } from "./TableBox";
import { AddGoodsModal } from "./AddGoodsModal";
import { useApplyListDetailsModel } from "./applyListDetailsModel";

export const ApplyAssetsListDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { addFormVal, editFormVal} = useApplyListDetailsModel();
    const dataSourse = detailsInfo.mode === 'add' ? addFormVal : editFormVal


    return (
        <>
            {detailsInfo && <>
                <FormBox {...detailsInfo} />
                {(dataSourse.typeCode == 'assets-apply-type.transfer'||dataSourse.typeCode == 'assets-apply-type.discard')&&<TableBox {...detailsInfo} />}
                <AddGoodsModal {...detailsInfo} />
            </>
            }
        </>
    )
}